import ApiService from '../../services/api.service';
import SectionModel from '../section/section-model';
import QuizanswerModel from '../quizanswer/quizanswer-model';
import MedialibraryModel from '../medialibrary/medialibrary-model';

export default class QuizquestionModel {
    id: number;
    name: string;
    description: string;
    status: string;
    section: any;
    sectionCaption: string;
    type: string;
    typeCaption: string;
    title: string;
    content: string;
    image: any;
    imageId: number;
    imageUrl: string;    
    seq: number;
    quizanswer: any;
    quizanswerLength: number;
    quizanswerSamples: any;
    quizanswerSamplesLength: number;
    quizanswerAnswer: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let section = datarow.section?.data? new SectionModel(datarow.section?.data) : datarow.section;
        this.section = section?.id;
        this.sectionCaption = section?.name;
        this.type = datarow.type || 'yesno';
        this.typeCaption = QuizquestionModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'Yes or No';
        this.title = datarow.title;
        this.content = datarow.content;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        this.seq = datarow.seq;
        this.quizanswer = datarow.quizanswer?.data?.map((d: any) => new QuizanswerModel(d));
        this.quizanswerLength = this.quizanswer?.length || 0;
        this.quizanswerSamples = this.seq<=0? this.quizanswer?.filter((d: any) => (d?.value > 0)) : null;
        this.quizanswerSamplesLength = this.quizanswerSamples?.length || 0;
        this.quizanswerAnswer = this.quizanswer?.[0]?.answer || '';
        
    } 

    public static endPoint: string = 'quiz-questions' 
    public static endPointMedia: string = 'api::quiz-question.quiz-question';
    public static endPointFilter: string = '?populate=*&sort=seq&filters[section]=';
    public static endPointFilter2: string = '?populate=*&sort=seq&filters[seq][$lt]=0&filters[section]=';
    public static url: string = '/quizquestion';
    public static caption: string = 'Quiz Question';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        section: null,
        sectionCaption: '',
        status: 'active',
        type: 'yesno',  
        typeCaption: 'Yes or No',
        title: '',
        content: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        seq: 0,
        quizanswer: [],
        quizanswerLength: 0,
        quizanswerSamples: null,
        quizanswerSamplesLength: 0,
        quizanswerAnswer: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'title', caption: 'Title' },
    ]

    public static columnPicklistCard = [
        { name: 'name', type: 'caption', size: 'medium', color: 'white', bgColor: 'primary.200', icon: 'blur_on'},
        { name: 'children', type: 'children', children: undefined, textAlign: 'center' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
        
    public static optionType = [
        { name: 'yesno', caption: 'Yes or No' },
        { name: 'optional', caption: 'Optional' },
        { name: 'optionalthin', caption: 'Optional Thin' },
        { name: 'multiple', caption: 'Multiple' },
        { name: 'multiplematch', caption: 'Multiple Match' },
        { name: 'freetext', caption: 'Free Text' },
        { name: 'letter', caption: 'Letter Only' },
        { name: 'letternumber', caption: 'Letter & Number' },
        { name: 'number', caption: 'Number' },
        { name: 'decimal', caption: 'Decimal' },
        { name: 'money', caption: 'Money' },
        { name: 'rating', caption: 'Rating' },
    ]

}